// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__MRzTF","header":"Messages_header__1h076"};